module.exports = __webpack_public_path__ + "img/infrastructure.24800fea.svg";